/**
 * Canonical icon-name list + shared Builder input schema for the two
 * IconPicker registrations (full registry + chrome registry). Strings only —
 * this module must not import any icon component, because the chrome registry
 * reaches it from the always-loaded layout chunk.
 *
 * ICON_NAMES must stay in sync with the full icon map in ./index.tsx — pinned
 * by tests/unit/hec/builder/chrome-registry.test.ts.
 */
export const ICON_NAMES = [
  "Svg401KMaximizer",
  "AcSearchArticleBgBorder",
  "Amex",
  "ArrowDown",
  "Arrow",
  "Bbb",
  "BrandLogo",
  "Calculator",
  "Call",
  "Chat",
  "LiveChat",
  "CheckBoxSelected",
  "Checkmark",
  "CircleCheckSolid",
  "CircleFacebookIcon",
  "Clipboard",
  "ClockLight",
  "CloseBlack",
  "CloseThin",
  "CloseWhite",
  "Close",
  "CollapseCaretDown",
  "Contact",
  "Dental",
  "Discover",
  "Download",
  "DrawerCloseIcon",
  "DropdownArrow",
  "EligibilityList",
  "EligibleProducts",
  "ElistFilterIcon",
  "Expand",
  "ExpenseWalletIcon",
  "EyeCare",
  "Facebook",
  "Faq",
  "FilterClose",
  "Flag",
  "FsaCalculator",
  "FsaTracker",
  "GlobalToolTip",
  "Google",
  "HelpContact",
  "HintIcon",
  "Hint",
  "Hitrust",
  "HsaPerksDashboard",
  "Heart",
  "IconCheckmark",
  "IconClose",
  "IconLoyalty3StepEarn",
  "IconLoyalty3StepRedeem",
  "IconLoyalty3StepShop",
  "Info",
  "Information",
  "Instagram",
  "LearningCenter",
  "Lightbulb",
  "LinkedIn",
  "Lock",
  "LogoFsaPerksNavy",
  "LogoHsaPerksNavy",
  "Mail",
  "Maintaince",
  "Mastercard",
  "Medical",
  "MiniCart",
  "Minus",
  "MobileMenu",
  "OhPrintIcon",
  "OhReturnIcon",
  "Optical",
  "WeightLoss",
  "Ring",
  "Insoles",
  "PartyHorn",
  "PastPurchases",
  "PhoneMobile",
  "Phone",
  "Pinch",
  "Plus",
  "Quiz",
  "Remove",
  "Reorder",
  "RxBottle",
  "SadFace",
  "SearchIcon",
  "Search",
  "Secure",
  "ShippingCheckMark",
  "SignOut",
  "StarHalf",
  "Star",
  "StdInfo",
  "SummaryFooterGeneralCall",
  "SummaryFooterGeneralChat",
  "TooltipDanderSolid",
  "Tooltip",
  "TooltipDanger",
  "TrackManageOrder",
  "TrackOrder",
  "Twitter",
  "UpArrow",
  "User",
  "Visa",
  "Wallet",
  "WaveLineFull",
  "WaveLineHorizontal",
  "WaveLineVertical",
  "Youtube",
  "Zoom",
  "ChevronDown",
  "MinicartClose",
] as const;

/**
 * Shared inputs for both IconPicker registrations. One array object on
 * purpose: the chrome-registry test pins `ChromeIconDefinition.inputs` to
 * `IconDefinition.inputs` by identity so the editor schema cannot drift.
 */
export const iconPickerInputs = [
  {
    name: "iconName",
    friendlyName: "Icon",
    type: "string",
    helperText: "Select from the available icon set",
    enum: [...ICON_NAMES],
    required: true,
    showIf: `options.get('useReference') !== true`,
  },
  {
    name: "useReference",
    friendlyName: "Reference a custom icon",
    helperText:
      "Reference a custom icon uploaded to the Custom Icons model via Builder",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "useBuilderImageAttributes",
    friendlyName: "Use Builder Image Attributes",
    helperText:
      "Apply attributes like width, height, and spacing set in the Builder editor",
    type: "boolean",
    defaultValue: true,
    showIf: `options.get('useReference') === true`,
  },
  {
    name: "CustomIcon",
    type: "reference",
    model: "custom-icons",
    required: true,
    showIf: `options.get('useReference') === true`,
  },
];
